import { useState, useEffect, useMemo } from 'react';
import { useRequest } from './useRequest';
import { useResponse } from './useResponse';
import { useDocumentActions, useDocumentApi } from '../actions';
import createUuid from 'uuid-random';

const nullValues = {
  all: [],
  paginate: [],
  find: null,
  first: null,
};

export function useFetch(fetchParams) {
  const [uuid] = useState(() => fetchParams.options?.debugUuid || createUuid()); // JSON.stringify({...fetchParams, action:fetchParams.action.verb,options:undefined}, null, 2))

  const { documentOpened, documentClosed } = useDocumentActions();
  useEffect(() => {
    documentOpened(uuid);
    return () => documentClosed(uuid);
  }, [uuid, documentOpened, documentClosed]);

  const request = useRequest(fetchParams);

  const response = useRunFetch({ uuid, request, options: fetchParams.options });

  return useMemo(
    () => ({ uuid, request, response }),
    [uuid, request, response],
  );
}

const useRunFetch = ({ uuid, request, options }) => {
  const {
    dynamic,
    onNew,
    onUpdate,
    onDestroy,
    initialValue: _initialValue,
  } = options;

  const nullValue = nullValues[request.action.verb];
  const [initialValue] = useState(_initialValue || nullValue);
  const { fetchDocument } = useDocumentApi();

  useEffect(() => {
    fetchDocument({
      uuid,
      request,
      options: { dynamic, onNew, onUpdate, onDestroy },
    });
  }, [uuid, fetchDocument, request, dynamic, onNew, onUpdate, onDestroy]);

  const response = useResponse({
    uuid,
    request,
    options: { initialValue, nullValue },
  });

  return response;
};
